import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'new-lead/:customerInfo',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const NewLeadContainer = require('./containers/NewLeadContainer').default
      const {
        leadManagementSaveReducer,
        leadPriceMasterReducer,
        leadSiteDetailsReducer
      } = require('./modules/leadManagement')

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'leadSaveStatus', reducer: leadManagementSaveReducer})
      injectReducer(store, {key: 'loadLeadPriceMaster', reducer: leadPriceMasterReducer })
      injectReducer(store, {key: 'loadSiteDetails', reducer: leadSiteDetailsReducer })


      /*  Return getComponent   */
      cb(null, NewLeadContainer)

      /* Webpack named bundle   */
    }, 'NewLead')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LeadCreation/index.js